<sew-tooltip direction="bottom" auto-width="true" slot="help">
    <p translate>ONLINE_HELP.FUNCTION_AVAILABLE</p>
    <sew-ws-link type="external">
        <a [href]="wikiHelpLink" target="_blank" translate>ONLINE_HELP.OPEN</a>
    </sew-ws-link>
    <sew-button hierarchy="tertiary" size="xs" icon="help" show-icon-only slot="target">
        <button [title]="tooltip ?? ''"></button>
    </sew-button>
</sew-tooltip>
